import { gql } from "gql";

export const GET_CURRENT_USER = gql(/* GraphQL */ `
  query GetCurrentUser {
    getCurrentUser {
      id
      username
      person {
        fullName
        id
      }
    }
  }
`);
